import { createReducer } from '@reduxjs/toolkit';
import { initialValidityState as initialState } from './state';
import * as actions from './action';
import { setNestedField } from '../utils';

export default createReducer(initialState(), (builder) => {
  builder
    .addCase(actions.setValidity, (state, { payload: { field, value } }) => {
      setNestedField(state, field, value);
    })
    .addCase(actions.resetValidity, (state) => {
      return initialState();
    });
});
